export const NAME = 'affiliate'

export const SET_AFFILIATE = `${NAME}/SET_AFFILIATE`

export const REMOVE_AFFILIATE = `${NAME}/REMOVE_AFFILIATE`
